import React from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";

const { Text } = Typography;

export default function ConfirmationModal({
  open,
  title = "Warning",
  content,
  onConfirm,
  onCancel,
  confirmLoading = false,
}) {
  return (
    <Modal
      open={open}
      title={null}
      onCancel={onCancel}
      footer={null}
      centered
      width={520}
      destroyOnClose
    >
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
        <ExclamationCircleFilled
          style={{ color: "#faad14", fontSize: "20px", marginTop: "2px" }}
        />
        <div>
          <Text strong style={{ display: "block", marginBottom: "6px" }}>
            {title}
          </Text>
          <Text>{content}</Text>
        </div>
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px",
        }}
      >
        <Button onClick={onCancel}>No</Button>
        <Button type="primary" danger loading={confirmLoading} onClick={onConfirm}>
          Yes
        </Button>
      </div>
    </Modal>
  );
}

